import { localhostApi } from './localhost-api';
import { isThisLocalhost } from '../framework/utils';
import { ApiClientBase } from '../framework/services/api-client-base';
import { LocalStorageService } from '../framework/services/local-storage';


export const REFRESH_TOKEN_KEY = 'AttHub.Refresh';

class RefreshApiClientClass extends ApiClientBase {
    constructor() {
        super();

        this.host = isThisLocalhost() ? localhostApi : window.location.origin;
        this.host = this.host + '/api';
    }

    protected acquireToken(): Promise<string> {
        const token = LocalStorageService.get(REFRESH_TOKEN_KEY) as string | null;
        return Promise.resolve(token ?? '');
    }
}

export const RefreshApiClient = new RefreshApiClientClass();